import { executeRequest, Request } from '@jfs/network'
import { checkPaymentLinkStatusParser } from '../network/parsers/CheckPaymentLinkStatusParser'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  const respData = checkPaymentLinkStatusParser(data)
  return respData
}

const checkPaymentLinkStatusRequest = (req: any, tokens: any, userAccessToken: string) => {
  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: APIEndPoints.checkPaymentLinkStatus,
    method: 'POST',
    body: req,
    headers: {
      Authorization: userAccessToken,
    },
  }
  return executeRequest(request).then((data) => {
    return responseParser(data?.data)
  })
}

export { checkPaymentLinkStatusRequest }
